// Used a separate file for bundling
export function isTextColorPanelSupported(
	zone: eXpress.core.IZone | undefined,
	dashboard: eXpress.TextZoneDashboard,
) {
	// We currently don't check if there are colors
	return dashboard.canSetTextColor(zone);
}
